module.exports = __webpack_public_path__ + "static/media/mobile-navigation-decoration.b978d160.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-navigation-decoration.svg
// module id = 1265
// module chunks = 0